/**
 * Values found for the parameters elsewhere, e.g. in the AI sources of an expert estimate;
 * a form that has none does not provide them
 */
export interface FoundDifferences {
    count: number;
    /** Values instead of the value of the field, items a multiple choice does not have, parts of a floor area */
    kind: 'values' | 'items' | 'parts';
}

export interface ParameterFoundValues {
    /** What differs from the value of the field, also one not saved yet */
    describeDifferences(name: string, value: any): FoundDifferences;

    show(name: string): void;
}

export const PARAMETER_FOUND_VALUES = 'parameterFoundValues';
